import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { pushModal } from 'loot-core/client/actions';

import { useDispatch } from '../../../redux';
import { Block } from '../../common/Block';
import { Button } from '../../ui/button2';
import { Modal, ModalCloseButton, ModalHeader } from '../../ui/modal';
import { Text } from '../../common/Text';
import { View } from '../../common/View';

function getErrorMessage(error: 'not-ynab4' | boolean) {
  switch (error) {
    case 'not-ynab4':
      return 'This file is not valid. Please select a .ynab4 file';
    default:
      return 'An unknown error occurred while importing. Please report this as a new issue on GitHub.';
  }
}

export function ImportModal() {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const [error] = useState(false);

  function onSelectType(type: 'ynab4' | 'ynab5' | 'actual') {
    switch (type) {
      case 'ynab4':
        dispatch(pushModal('import-ynab4'));
        break;
      case 'ynab5':
        dispatch(pushModal('import-ynab5'));
        break;
      case 'actual':
        dispatch(pushModal('import-actual'));
        break;
      default:
    }
  }

  const itemStyle = {
    padding: 10,
    border: '1px solid var(--color-tableBorder)',
    borderRadius: 6,
    marginBottom: 10,
    display: 'block',
  };

  return (
    <Modal name="import" containerProps={{ style: { width: 400 } }}>
      {({ state: { close } }) => (
        <>
          <ModalHeader
            title={t('Import From')}
            rightContent={<ModalCloseButton onClick={close} />}
          />
          <View style={{ fontSize: 13, lineHeight: 1.5 }}>
            {error && (
              <Block className="text-destructive" style={{ marginBottom: 15 }}>
                {getErrorMessage(error)}
              </Block>
            )}

            <Text style={{ marginBottom: 15 }}>
              Select an app to import from, and we’ll guide you through the
              process.
            </Text>

            <Button style={itemStyle} onClick={() => onSelectType('ynab4')}>
              <span style={{ fontWeight: 700 }}>YNAB4</span>
              <View className="text-[var(--color-pageTextLight)]">
                <Trans>The old unsupported desktop app</Trans>
              </View>
            </Button>
            <Button style={itemStyle} onClick={() => onSelectType('ynab5')}>
              <span style={{ fontWeight: 700 }}>nYNAB</span>
              <View className="text-[var(--color-pageTextLight)]">
                <div>
                  <Trans>The newer web app</Trans>
                </div>
              </View>
            </Button>
            <Button style={itemStyle} onClick={() => onSelectType('actual')}>
              <span style={{ fontWeight: 700 }}>Actual</span>
              <View className="text-[var(--color-pageTextLight)]">
                <div>
                  <Trans>Import a file exported from Actual</Trans>
                </div>
              </View>
            </Button>
          </View>
        </>
      )}
    </Modal>
  );
}
